"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeAction = exports.createLocalizeAction = exports.selectLanguage = exports.resetLanguage = void 0;
const Keys_1 = require("./Keys");
const resetLanguage = () => ({
    type: Keys_1.LocalizeActionKeys.Reset,
    payload: undefined,
});
exports.resetLanguage = resetLanguage;
const selectLanguage = (payload) => ({
    type: Keys_1.LocalizeActionKeys.Select,
    payload,
});
exports.selectLanguage = selectLanguage;
const createLocalizeAction = () => ({
    resetLanguage: exports.resetLanguage,
    selectLanguage: exports.selectLanguage,
});
exports.createLocalizeAction = createLocalizeAction;
exports.localizeAction = (0, exports.createLocalizeAction)();
